angular.module("ainapp")
    .controller("serviceCategoryController", ["app.config", "$scope", "LoginService", "AuthenticationService", "$state", "$stateParams", "MainService", "localStorageService",
            function (config, $scope, LoginService, AuthenticationService, $state, $stateParams, MainService, localStorageService) {


            $scope.PageName = "Service Category";
            $scope.TokenInfo = AuthenticationService.getTokenInfo();
            if ($scope.TokenInfo == null) {
                $state.go("login");
            } else {
                $scope.checkUserPageAccess($scope.PageName);
            }


            $scope.Init = function () {
                $scope.City = {
                    Name: "",
                    NameAr: "",
                    ProductCode: "",
                    Order: 0,
                    ProductType: "Service",
                }

                $scope.load = 0;

                $scope.ProductParents = [];
                MainService.ProductParentCategoriesByType("Service").then(function (response) {
                    $scope.ProductParents = response.data;
                })
            }
            $scope.Init();

            $scope.KendoSource = new kendo.data.DataSource({
                batch: true,
                transport: {
                    read: function (o) {
                        o.data.ProductType = "Service";
                        MainService.ProductCategoriesInView(o.data).then(function (response) {
                            o.success(response.data);
                        }, function (err) {
                            o.success({
                                Data: []
                            });
                            toastr.error("NetworkError");
                        })
                    },

                },
                change: function (data) {},
                schema: {
                    data: "Data",
                    total: "Total",
                    model: {
                        id: "Id",
                        fields: {
                            Name: {
                                type: "string",
                                editable: false,
                            },
                            NameAr: {
                                type: "string",
                                editable: false,
                            },
                            ProductCode: {
                                type: "string",
                                editable: false,
                            },
                            Order: {
                                type: "number",
                                editable: false,
                            },
                            "ProductCategory.Name": {
                                type: "string",
                                editable: false,
                            },

                        }
                    }
                },
                serverPaging: true,
                serverSorting: true,
                serverFiltering: true,
                pageSize: 20,
            });

            $scope.KendoGridOptions = {

                editable: false,
                pageable: true,
                toolbar: ["excel"],
                height: 600,
                resizable: true,
                dataSource: $scope.KendoSource,
                pageSize: 20,
                pageable: {
                    input: false,
                    refresh: true,
                    pageSizes: true,
                    info: true,
                },
                sortable: true,
                scrollable: true,
                filterable: true,
                columnMenu: {
                    filterable: false,
                    filterable: true,
                },
                columns: [
                    {
                        field: "Name",
                        title: "Name",
                        headerTemplate: "{{LanguageData.Name}}",
                        },
                    {
                        field: "NameAr",
                        title: "Name Ar",

                        },
                    {
                        field: "ProductCode",
                        title: "Code",
                        },
                    {
                        field: "ProductCategory.Name",
                        title: "Parent Category",
                        },
                    {
                        field: "Order",
                        title: "Order",
                        },

                    {
                        title: "Options",
                        headerTemplate: "{{LanguageData.Options}}  ",
                        template: "<button class=' btn-default btn-sm fa fa-pencil' ng-click='Edit(dataItem)'> </button> <button class=' btn-default btn-sm fa fa-trash'  ng-click='DeleteAccType(dataItem)'></button>  ",
                        width: '80px'
                        },
                    ],
            };

            $scope.Update = function () {
                $("#Kendo-Grid").data("kendoGrid").dataSource.sync();
            }
            $scope.Cancel = function () {
                $("#Kendo-Grid").data("kendoGrid").dataSource.cancelChanges();
            }

            $scope.SelectedDataForDelete = {};
            $scope.DeleteAccType = function (data) {
                if (!$scope.PageAccessInfo.IsRemove) {
                    toastr.info("You Dont Have Access To Delete Data, Please Contact Admin");
                } else {
                    $scope.SelectedDataForDelete = data;
                    $("#deleteModal").modal("show");
                }
            }


            $scope.deleteWithConfirm = function () {
                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });
                MainService.DeleteProductCategory($scope.SelectedDataForDelete.Id).then(function (response) {
                    if (response.data == 1) {
                        $('#deleteModal').modal('hide');
                        toastr.success("Deleted");
                        $("#Kendo-Grid").data("kendoGrid").dataSource.read();
                        $scope.SelectedDataForDelete = {};
                    } else if (response.data == 2) {
                        toastr.error("Sub Products / Categories Found.");
                    } else {
                        toastr.error("Network Error");
                    }
                    $.LoadingOverlay("hide");
                }, function (err) {
                    toastr.error("Network Error");
                    $.LoadingOverlay("hide");
                });
            }

            $scope.Edit = function (data) {
                $scope.City = data;
                //$scope.$apply();
            }




            $scope.AddData = function () {
                if (!$scope.PageAccessInfo.IsAdd && !$scope.City.Id > 0) {
                    toastr.info("You Dont Have Access To Add Data, Please Contact Admin");
                } else if (!$scope.PageAccessInfo.IsEdit && $scope.City.Id > 0) {
                    toastr.info("You Dont Have Access To Edit Data, Please Contact Admin");
                } else if ($scope.City.Name == "") {
                    toastr.warning("Enter Name");

                } else if ($scope.City.ProductCode == "") {
                    toastr.warning("Enter Code");

                } else {
                    $.LoadingOverlay("show", {
                        image: "images/load.gif",
                    });
                    $scope.City.Level = 1;
                    MainService.AddProductCategory($scope.City).then(function (response) {
                        if (response.data) {
                            $("#Kendo-Grid").data("kendoGrid").dataSource.read();
                            toastr.success("Success");

                            $scope.Init();
                            $scope.load = 0;
                        } else {
                            toastr.error("Error");
                            $scope.load = 0;
                        }
                        $.LoadingOverlay("hide");
                    }, function (err) {
                        toastr.error("Network Error");
                        $.LoadingOverlay("hide");
                    });
                }
            }

                }])
